import {
    Box,
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Alert,
    AlertDescription,
    AlertIcon
} from '@chakra-ui/react'
import { useRef } from 'react'

type Props = {
    handleConfirm: () => void
    loading: boolean
    isOpen: boolean
    onClose: () => void
}

export default function ConfirmRole({ handleConfirm, loading, isOpen, onClose }: Props) {
    const cancelRef = useRef()
    return (
        <AlertDialog
            // @ts-expect-error Chakra AlertDialog ref prop typing
            leastDestructiveRef={cancelRef}
            isOpen={isOpen}
            onClose={onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader color={'red'}>
                        Are you sure of your request?
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        <Alert
                            status="warning"
                            borderRadius="6"
                            my={4}
                            width="fit-content"
                        >
                            <AlertIcon />
                            <Box>
                                <AlertDescription>
                                    Using the role request feature carelessly may cause
                                    your account to be blocked and reported to the
                                    pastorate!
                                </AlertDescription>
                            </Box>
                        </Alert>
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            // @ts-expect-error Chakra ref prop typing
                            ref={cancelRef}
                            onClick={onClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            colorScheme="gray"
                            onClick={handleConfirm}
                            isLoading={loading}
                            ml={3}
                        >
                            Submit Request
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}
